
import React, { useState } from "react";
import ShopifyModal from "../../../../../components/ShopifyModal";
import { reqPostRedeemCancelOrder } from "../../../../../api";
const Index = ({removeData,setRemoveData,resetCallback}) => {
    const [saveLoading, setSaveLoading] = useState(false);
    const handleSave = async () => {
        setSaveLoading(true);
        let res = await reqPostRedeemCancelOrder({dsm_order_id:removeData.id})
        if (res.code === '200') {
          setRemoveData((prevValue)=>({...prevValue,open:false}))
          resetCallback()
        }
      };
  return (
    <div className="upgrade_new_feature">
      <ShopifyModal id="cancel-redemption-modal"
        open={removeData.open}
        onClose={() => 
          {
            setRemoveData((prevValue)=>({...prevValue,open:false}))
            setSaveLoading(false)
          }}
        heading={'Cancel Product Redemption'}
        primaryAction={{
          content: "Yes",
          loading:saveLoading,
          onAction: () => {
            handleSave()
          },
        }}
        secondaryActions={[
          {
            content: "No",
            onAction: () => {
              setRemoveData((prevValue)=>({...prevValue,open:false}))
              setSaveLoading(false)
            }
          },
        ]}
      >
        <p style={{fontSize:'14px'}}>{'After canceling, this product redemption will be removed, and the points will be refunded. Are you sure you want to cancel?'}</p>
        </ShopifyModal>
    </div>
  );
};

export default Index;
